import * as React from 'react'
import { FC } from 'react'
import { EditableCellCtx } from '../../../../../../../../../../components/editable-cell/editable-cell'
import { Form, InputNumber } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import formatIntegerBySpace from '../../../../../../../../../../helpers/formatters/format-integer-by-space'

interface EditSumProps {
    namePath: NamePath
}

const EditNumber: FC<EditSumProps> = ({ namePath }) => {
    const ctx = React.useContext(EditableCellCtx)
    return (
        <Form.Item name={namePath} noStyle>
            <InputNumber
                autoFocus
                onBlur={ctx.onBlur}
                formatter={formatIntegerBySpace}
                style={{ width: '100%', height: '100%' }}
            />
        </Form.Item>
    )
}

export default EditNumber
